import { render, staticRenderFns } from "./SignaturesSummaryBadge.vue?vue&type=template&id=97334d12&scoped=true&lang=pug"
import script from "./SignaturesSummaryBadge.vue?vue&type=script&lang=js"
export * from "./SignaturesSummaryBadge.vue?vue&type=script&lang=js"
import style0 from "./SignaturesSummaryBadge.vue?vue&type=style&index=0&id=97334d12&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97334d12",
  null
  
)

export default component.exports